import i18n from './config';

function getLocale(override?: string): string {
  return override || (typeof i18n !== 'undefined' && i18n.language) || 'pt-BR';
}

/** Formata número de acordo com o locale ativo (i18n.language). */
export function formatarNumero(
  valor: number | null | undefined,
  options?: Intl.NumberFormatOptions,
  locale?: string,
): string {
  if (valor === null || valor === undefined || Number.isNaN(Number(valor))) {
    return '0';
  }
  return new Intl.NumberFormat(getLocale(locale), options).format(Number(valor));
}

/** Formata data de acordo com o locale ativo (i18n.language). */
export function formatarData(
  data: Date | string | number | null | undefined,
  options?: Intl.DateTimeFormatOptions,
  locale?: string,
): string {
  if (!data) return '';
  const d = data instanceof Date ? data : new Date(data);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(getLocale(locale), options).format(d);
}

/** Formata data e hora de acordo com o locale ativo (i18n.language). */
export function formatarDataHora(
  data: Date | string | number | null | undefined,
  options?: Intl.DateTimeFormatOptions,
  locale?: string,
): string {
  if (!data) return '';
  const d = data instanceof Date ? data : new Date(data);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(getLocale(locale), options).format(d);
}

/** Formata moeda de acordo com o locale ativo (i18n.language). */
export function formatarMoeda(
  valor: number | null | undefined,
  moeda = 'BRL',
  locale?: string,
): string {
  if (valor === null || valor === undefined || Number.isNaN(Number(valor))) {
    return formatarMoeda(0, moeda, locale);
  }
  return new Intl.NumberFormat(getLocale(locale), {
    style: 'currency',
    currency: moeda,
  }).format(Number(valor));
}
